<ng-container [formGroup]="form">
        <input type="control.sub_type" [formControl]="getFormControl()"
                [placeholder]="control.placeholder" [id]="control.key" class="form-control"
                [ngClass]="{'is-invalid': isFormSubmitted && !isValid}">
</ng-container>